import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_factory4.png",
      alt: "Estratégias Factory4",
    },
    title: "Potencialize seus investimentos com a Factory4",

    // String ou array de strings
    text: [
      "Com mais de 15 anos de experiência no mercado financeiro, nossa equipe de traders altamente qualificados agora traz toda essa expertise para o desenvolvimento de robôs de automação de trading.",
      "Nossos robôs são projetados para otimizar suas estratégias de investimento, visando uma operação eficiente, precisa e altamente lucrativa.",
    ],
    testimonial: {
      text: "Nossa maior preocupação é trazer ao cliente produtos eficientes, que de fato trarão tranquilidade e performance.",
      author: {
        name: "Henrique Pena. Estrategista Chefe e Analista CNPI-T da Factory4 Traders.",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Factory4",
    heading: "Algoritmos exclusivos para potencializar seus investimentos.",
    subtitle: "15 anos de experiência em alguns cliques. Comece agora mesmo.",
  },

  cta: {
    title: "Pronto para Iniciar?",
    subtitle: "Ative agora mesmo a extensão Factory4.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Factory4",
    col1: [
      "A Factory4 Traders é formada por um time de especialistas no mercado financeiro e tecnologia, composto por Diego Novacki, CEO e programador de estratégias com experiência no mercado financeiro desde 2005, Henrique Pena, Estrategista Chefe e analista CNPI-T com vasta experiência em derivativos e futuros desde 2009, e Pedro Barletta, CTO, Engenheiro Mecânico e programador com habilidades em diversas linguagens e foco em estatística.",
      "A empresa surgiu de um sonho de disponibilizar ao público as estratégias utilizadas ao longo de anos por nossos traders profissionais. Unidos pela visão de superar os desafios psicológicos enfrentados pelos traders, desenvolvemos e aprimoramos estratégias eficazes que são disponibilizadas por meio de nossos robôs automatizados.",
    ],
    col2: [
      "Nossa missão é ajudar traders de todos os níveis a aproveitar as vantagens da automação no mercado financeiro.",
    ],
  },

  stats: {
    title: "Números da Factory4",
    subtitle: "Nossa experiência real acessível aos nossos clientes",
    data: [
      {
        value: "+15",
        description: "Traders com mais de 15 anos de mercado.",
      },
      {
        value: "+2k",
        description:
          "Média de pontos mensais no Mini Índice nos últimos 12 meses.",
      },
      {
        value: "+30k",
        description: "Pontos no Mini Índice nos últimos 12 meses.",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Factory4.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Nossos robôs são totalmente automatizados, o que significa que operam de forma autônoma, sem a necessidade de intervenção humana constante, proporcionando uma experiência de negociação eficiente e sem a necessidade de passar horas monitorando o mercado.",
      },
      {
        icon: iconsSet.favorite,
        title: "Efeito Emocional",
        description:
          "A automação de estratégias elimina o efeito emocional nas operações, um dos principais obstáculos enfrentados pelos traders, permitindo uma abordagem objetiva e consistente baseada em parâmetros predefinidos, sem ser influenciado por medo, ganância ou emoções humanas.",
      },
      {
        icon: iconsSet.growth,
        title: "Não perca Operações",
        description:
          "Nossos robôs executam as estratégias de forma disciplinada e constante, visando que nenhuma oportunidade de negociação seja perdida, o que é crucial em um mercado financeiro dinâmico e de rápida movimentação.",
      },
      {
        icon: iconsSet.test_tube,
        title: "Backtests Efetivos",
        description:
          "Antes de serem implementadas em tempo real, nossas estratégias são rigorosamente testadas em backtests efetivos, utilizando dados históricos para verificar sua eficácia e consistência, permitindo uma abordagem baseada em dados e resultados concretos.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Nossos clientes têm acesso a suporte individualizado, com uma equipe dedicada pronta para ajudar com dúvidas, configurações e assistência técnica, garantindo que recebam o suporte necessário para obter o máximo benefício de nossos robôs automatizados.",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Oferecemos aos nossos clientes um período de teste de 7 dias para experimentar nossos robôs em ambiente real ou simulado de mercado, permitindo que avaliem sua performance e se familiarizem com o funcionamento dos robôs antes de investir financeiramente.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Num mercado como o brasileiro, com baixa liquidez e interesse, movimentado principalmente por notícias políticas e econômicas.. fica essencial que seus participantes dominem seus vieses emocionais ou que transfiram tais responsabilidades para os HFT, dito isso, uma vez que você escolha a segunda opção, os robôs programados pela Factory4 são espetaculares, vale o teste!",
      author: "Junior Vimieiro",
      job: "Analista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Eu nunca imaginei que robôs poderiam fazer isso. Os robôs da Factory4 são muito bons, sem emoções. Estou feliz por ter encontrado uma solução para melhorar minha rentabilidade.",
      author: "Renato Terra",
      job: "Empresário",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Factory4",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
